import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { RxCross1 } from 'react-icons/rx';
import { Button, Card, CardBody, CardHeader, Col, Label, ListGroup, ListGroupItem, Row, TabContent, TabPane } from 'reactstrap';

import { GET_BOOKING_DETAILS_EMPTY } from '../../../../../../../store/actions';
import { Constant } from '../../../../../../Helpers/constant';
import airplane from '../../../../../../../assets/images/airplane.svg';

import zone from '../../../../../../../assets/images/zone.svg';

export default function Summary({ details, currentSelectedBooking, setCurrentSelectedBooking, setCurrentActiveBookingAction, title }) {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [currentActiveTab, setCurrentActiveTab] = useState(0);
  const [changeLogs, setChangeLogs] = useState(null);

  const [selectedDetailsIndex, setSelectedDetailsIndex] = useState(null);
  const [selectedAirportIndex, setSelectedAirportIndex] = useState(null);

  useEffect(() => {
    scrollToSection('summary-section');
  }, [details]);

  useEffect(() => {
    setCurrentActiveTab(0);
  }, [currentSelectedBooking]);

  const scrollToSection = elementName => {
    const section = document.getElementById(elementName);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const getUserType = () => {
    return parseInt(JSON.parse(window.localStorage.getItem('userType') ?? -1));
  };

  return (
    <>
      <Row id="summary-section">
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex justify-content-end">
              <h4 className="card-title mb-0 flex-grow-1 fw-semibold fs-5">
                {title?.split(' ')?.[0] || 'Client Id'} -{' '}
                <span className="fw-normal text-decoration-underline">{currentSelectedBooking?.name || currentSelectedBooking?.id}</span>{' '}
              </h4>

              <div className="d-flex gap-3 align-items-center">
                {currentSelectedBooking?.bookingType === 'airport_transfers' && currentSelectedBooking?.actions?.includes(`modify_booking`) && (
                  <Button
                    className="customized-btn warning"
                    color="warning"
                    onClick={() => {
                      setCurrentActiveBookingAction(`modify_booking`);
                    }}
                  >
                    Modify
                  </Button>
                )}

                {currentSelectedBooking?.bookingType === 'golf' &&
                  getUserType() !== Constant?.userTypes?.VENDOR_USER_V2 &&
                  ['modify_player', 'reject-slot', 'suggest_new_golf_course']?.some(action => currentSelectedBooking?.actions?.includes(action)) && (
                    <Button
                      className="customized-btn warning"
                      color="warning"
                      onClick={() => {
                        setCurrentActiveBookingAction(`modify_booking`);
                      }}
                    >
                      Modify
                    </Button>
                  )}

                {currentSelectedBooking?.actions?.includes(`cancel_booking`) && (
                  <Button
                    className="customized-btn danger"
                    onClick={() => {
                      console.log('I am here', currentSelectedBooking?.isShortNoticeCancel);
                      if (currentSelectedBooking?.isShortNoticeCancel) {
                        setCurrentActiveBookingAction(`short_notice_cancel_booking`);
                      } else {
                        setCurrentActiveBookingAction(`cancel_booking`);
                      }
                    }}
                  >
                    Cancel Booking
                  </Button>
                )}
                <span
                  className="cancel-details-icon"
                  onClick={() => {
                    dispatch({
                      type: GET_BOOKING_DETAILS_EMPTY,
                    });
                    setCurrentSelectedBooking(null);
                  }}
                >
                  <RxCross1 />
                </span>
              </div>
            </CardHeader>

            <CardHeader className="d-flex justify-content-end p-0">
              <div className="custom-tabs-container">
                {details?.result?.map((bookingDetail, index) => {
                  return (
                    <div
                      className={`custom-tab ${index === currentActiveTab ? 'active' : ''}`}
                      key={index}
                      onClick={() => {
                        setCurrentActiveTab(index);
                        setChangeLogs(null);
                      }}
                    >
                      {bookingDetail?.tabDetails?.tabHeading}
                    </div>
                  );
                })}
              </div>
            </CardHeader>

            <CardBody>
              <TabContent activeTab={currentActiveTab}>
                {details?.result?.map((bookingDetail, index) => {
                  if (bookingDetail?.tabDetails?.tabHeading === `Booking Logs`) {
                    return (
                      <TabPane tabId={index} key={index} className="mt-2">
                        <Row className="pe-4">
                          <Col md={12}>
                            <div className="modification-wrapper">
                              {bookingDetail?.tabDetails?.data?.map((logDetail, index) => (
                                <>
                                  <div
                                    className="modification-container"
                                    key={index}
                                    style={{
                                      cursor: `${logDetail?.isActionAble?.status ? 'pointer' : 'unset'}`,
                                    }}
                                    onClick={() => {
                                      setSelectedDetailsIndex(index);
                                      setChangeLogs(logDetail?.isActionAble?.status ? logDetail?.isActionAble : null);
                                    }}
                                  >
                                    <div className="d-flex gap-3 align-items-start">
                                      <div style={{ color: `${logDetail?.color || '#405189'}` }}>
                                        <i className="mdi mdi-24px mdi-circle-slice-8" />
                                      </div>

                                      <div className="modification-details-section">
                                        <p className="modification-status-tag" style={{ color: `${logDetail?.color || ''}` }}>
                                          {logDetail?.bookingStatus || `NA`}
                                        </p>
                                        <p className="modification-date">Date - {logDetail?.dateTime || ``}</p>

                                        {Boolean(`${logDetail?.actionBy}`?.trim()) && (
                                          <p className="modification-action-by">Action by - {logDetail?.actionBy || `NA`}</p>
                                        )}

                                        {Boolean(`${logDetail?.remarks}`?.trim()) && (
                                          <p className="modification-remarks-section">
                                            Remarks - <span className="modification-remarks">{logDetail?.remarks || `NA`}</span>
                                          </p>
                                        )}
                                      </div>

                                      {changeLogs !== null && selectedDetailsIndex === index && changeDetails(changeLogs)}
                                    </div>
                                  </div>
                                </>
                              ))}
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                    );
                  } else if (bookingDetail?.tabDetails?.tabHeading === `Modify Details`) {
                    return (
                      <>
                        <TabPane tabId={index} key={index} className="mt-2">
                          <Row>
                            {changeDetails(
                              {
                                prevState: bookingDetail?.tabDetails?.data?.[0]?.details,
                                currentState: bookingDetail?.tabDetails?.data?.[1]?.details,
                              },
                              'Modify Details',
                            )}
                          </Row>
                        </TabPane>
                      </>
                    );
                  } else if (bookingDetail?.tabDetails?.tabHeading === `Config Details`) {
                    return (
                      <TabPane tabId={index} key={index} className="mt-2">
                        <Row className="mb-5">
                          <Col md="5">
                            {bookingDetail?.tabDetails?.data?.[0]?.details?.map((configDetail, index) => (
                              <div
                                key={index}
                                tag="button"
                                action
                                className="mt-2 fs-11 d-flex justify-content-between align-items-center"
                                onClick={() => setSelectedAirportIndex(index)}
                                style={{
                                  padding: '12px 16px',
                                  marginBottom: '8px',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  backgroundColor: selectedAirportIndex === index ? '#dfe6f5' : '#f8f9fa',
                                  border: selectedAirportIndex === index && '1px solid #4b6cb7',
                                  fontWeight: selectedAirportIndex === index ? '600' : '500',
                                  color: selectedAirportIndex === index ? '#1a1a2e' : '#333',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <img src={airplane} style={{ width: '20px' }} alt="Airport Icon" />
                                  <div>
                                    <div>{configDetail?.heading}</div>
                                    <div className="d-flex align-items-center gap-2">
                                      {configDetail?.counts?.map((count, cIndex) => (
                                        <div key={cIndex} className="fs-10">
                                          <img src={zone} alt="" width={15} />
                                          <span className="fs-12">{count?.value}</span>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                                <i className="ri-arrow-right-s-line fs-16"></i>
                              </div>
                            ))}
                          </Col>
                          {selectedAirportIndex !== null && (
                            <Col md="6" className="pt-3 px-4 pe-4 mx-2" style={{ border: '1px solid #8291C5', borderRadius: '10px' }}>
                              {bookingDetail?.tabDetails?.data?.[0]?.details?.[selectedAirportIndex]?.subDetails?.map((zone, index, arr) => {
                                const isLast = index === arr.length - 1;
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      borderBottom: isLast ? 'none' : '1px solid #ddd',
                                      paddingBottom: '12px',
                                      marginBottom: isLast ? '0' : '12px',
                                    }}
                                  >
                                    <p className="fw-semibold mb-1">
                                      {zone?.heading} - <span className="fw-normal">Vendor</span>
                                    </p>

                                    <div className="d-flex flex-wrap gap-2">
                                      {zone?.subDetails?.map((vendor, vIndex) => (
                                        <div className="pills-type-values-container" key={vIndex}>
                                          <span className="pills-type-value fs-10">{vendor?.value || '-'}</span>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                );
                              })}
                            </Col>
                          )}
                        </Row>
                      </TabPane>
                    );
                  } else {
                    return (
                      <TabPane tabId={index} key={index} className="mt-2">
                        <Row>
                          {bookingDetail?.tabDetails?.data?.map((tabDetail, index) => {
                            return (
                              <Row key={index}>
                                <Col md={12}>
                                  <p className="text-primary custom-section-heading">{tabDetail?.sectionHeading}</p>
                                </Col>

                                {tabDetail?.details?.map((details, index) => {
                                  return (
                                    <Col md={`${details?.metaInfo?.type === 'guest' ? 3 : 4}`} key={index}>
                                      <div className="mb-2 d-flex flex-column">
                                        {details?.heading && (
                                          <>
                                            <Label className="custom-section-label">
                                              {details?.icon && <img src={details?.icon} />}
                                              {details?.heading || '-'}
                                            </Label>
                                          </>
                                        )}
                                        <Label className="custom-section-text">
                                          {details?.metaInfo?.type === 'location' && (
                                            <span
                                              className="location-type-value"
                                              onClick={() => {
                                                const { lat, long } = details?.metaInfo || {};
                                                const googleMapsUrl = `https://www.google.com/maps?q=${lat},${long}&ll=${lat},${long}&z=14`;

                                                window.open(googleMapsUrl, '_blank');
                                              }}
                                            >
                                              {details?.value || '-'}
                                              {details?.metaInfo?.icon && <img src={details?.metaInfo?.icon} alt="Location Icon" />}
                                            </span>
                                          )}

                                          {details?.metaInfo?.type === 'pills' && (
                                            <div className="pills-type-values-container">
                                              {details?.value?.split(',')?.map((pills, index) => (
                                                <span className="pills-type-value" key={index}>
                                                  {pills || '-'}
                                                </span>
                                              ))}
                                            </div>
                                          )}

                                          {!['pills', 'location']?.includes(details?.metaInfo?.type) && (
                                            <span style={{ color: details?.metaInfo?.color || '#121639' }}>{details?.value || '-'}</span>
                                          )}
                                        </Label>
                                      </div>
                                    </Col>
                                  );
                                })}
                              </Row>
                            );
                          })}
                        </Row>
                      </TabPane>
                    );
                  }
                })}
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
}

const DetailItem = ({ label, value, highlight, isColor }) => {
  return (
    <div className="modified-item">
      <span className="modified-label">{label}</span>
      <span className={`modified-value`} style={{ color: isColor ? isColor : '#121639' }}>
        {value}
      </span>
    </div>
  );
};

const changeDetails = (data, flag = '') => {
  return (
    <>
      <div className={`booking-truncate-details ${flag === `Modify Details` ? 'modify-details' : ''} `}>
        <div className="booking-prev-details-section">
          <p className="modification-section-heading">Booking Details</p>
          {data?.prevState?.map((pState, index) => (
            <DetailItem key={index} label={pState?.heading || `NA`} value={pState?.value || `NA`} />
          ))}
        </div>
        <div className="booking-prev-next-section">
          <p className="modification-section-heading">Modified Booking Details</p>

          {data?.currentState?.map((cState, index) => (
            <DetailItem key={index} label={cState?.heading || `NA`} value={cState?.value || `NA`} isColor={'#EA9C2B'} />
          ))}
        </div>
      </div>
    </>
  );
};
